/* import __COLOCATED_TEMPLATE__ from './attributes.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { get } from 'embercom/lib/ajax';
import type Conversation from 'embercom/objects/inbox/conversation';
import type Inbox from 'embercom/objects/inbox/inboxes/inbox';
import { type CompanyAttributes } from 'embercom/objects/inbox/company';
import type ExternalPlan from 'embercom/objects/inbox/external-plan';
import type Session from 'embercom/services/session';
import { type UserAttributeWithIconLinkParams } from '../user-details';
import { use } from 'ember-resources/util/function-resource';
import { AsyncData } from 'embercom/resources/utils/async-data';

interface Args {
  isLoading: boolean;
  attributes: UserAttributeWithIconLinkParams[];
  plans: ExternalPlan[];
  company: CompanyAttributes;
  conversation: Conversation;
  activeInbox: Inbox;
  showPinIcon: boolean;
  hideRowIcon?: boolean;
  togglePin: () => unknown;
  hideLabel?: boolean;
}

interface Signature {
  Args: Args;
}

export default class Inbox2CompanyDetailsAttributes extends Component<Signature> {
  @service declare session: Session;

  get planName() {
    return this.planLoader.value?.name || '';
  }

  @use private planLoader = AsyncData<ExternalPlan | null>(async () => {
    if (!this.args.company.plan_id) {
      return null;
    }

    let plan =
      this.args.plans.find((plan) => plan.id === this.args.company.plan_id?.toString()) ?? null;

    if (plan) {
      return plan;
    } else {
      try {
        return (await get(`/ember/external_plans/${this.args.company.plan_id}`, {
          app_id: this.session.workspace.id,
        })) as ExternalPlan;
      } catch (error) {
        return null;
      }
    }
  });
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationDetailsSidebar::SidebarSections::CompanyDetails::Attributes': typeof Inbox2CompanyDetailsAttributes;
    'inbox2/conversation-details-sidebar/sidebar-sections/company-details/attributes': typeof Inbox2CompanyDetailsAttributes;
  }
}
